<template>
    <nav class="navbar navbar-expand-lg navbar-light">
        <div class="container-fluid">
            <router-link :to="{ name: user ? 'dashboard' : 'login' }"
                         class="navbar-brand">
                <img :src="logoUrl" :title="appName">
            </router-link>

            <button class="navbar-toggler" type="button" data-toggle="collapse"
                    data-target="#navbarToggler" aria-controls="navbarToggler"
                    aria-expanded="false">
                <span class="navbar-toggler-icon"/>
            </button>

            <div id="navbarToggler" class="collapse navbar-collapse">
                <ul class="navbar-nav">
                    <!-- <li class="nav-item">
                      <a class="nav-link" href="#">Link</a>
                    </li> -->
                </ul>

                <ul class="navbar-nav ml-auto">
                    <!-- Authenticated -->
                    <li v-if="user" class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle text-light"
                           href="#" role="button" data-toggle="dropdown"
                           aria-haspopup="true" aria-expanded="false">
                            <img :src="user.photoUrl"
                                 class="rounded-circle profile-photo mr-1">
                            {{ user.name }}
                        </a>
                        <div class="dropdown-menu">
                            <router-link :to="{ name: 'settings.profile' }"
                                         class="dropdown-item pl-3">
                                <fa icon="cog" fixed-width/>
                                Settings
                            </router-link>

                            <div class="dropdown-divider"/>
                            <a href="#" class="dropdown-item pl-3"
                               @click.prevent="logout">
                                <fa icon="sign-out-alt" fixed-width/>
                                Log Out
                            </a>
                        </div>
                    </li>
                    <!-- Guest -->
                    <template v-else>
                        <li class="nav-item">
                            <router-link :to="{ name: 'login' }"
                                         class="nav-link text-light"
                                         active-class="active">
                                Log In
                            </router-link>
                        </li>
                    </template>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {

        data: () => ({
            appName: window.config.appName,
            logoUrl: window.config.logoUrl
        }),

        computed: mapGetters({
            user: 'auth/user'
        }),

        methods: {
            async logout() {
                // Log out the user.
                await this.$store.dispatch('auth/logout')

                // Redirect to login.
                this.$router.push({name: 'login'})
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Navbar.vue